import React, { useState } from 'react'
import {
  type IPickerListItem,
  Picker,
  Text,
  DesignToken,
} from '@livechat/design-system-react-components'

import useParamSelector from '@/hooks/useParamSelector'
import { getPaymentIntent } from '@/store/payment/selectors'
import { useTypedDispatch, useTypedSelector } from '@/store/hooks'
import {
  getChargeType,
  getPaymentCharge,
  getPaymentItem,
  isUpdatingBillingCycle,
} from '@/store/selectors'
import { createCharge } from '@/store/payment'
import { BILLING_OPTIONS, PAYMENT } from '@/constants'
import { withVar } from '@/utils/styles'
import {
  calculateUpdatedChargePrice,
  getBillingCycleOption,
} from '@/utils/products'

const optionsList = Object.values(BILLING_OPTIONS)

const BillingCyclePicker = () => {
  const dispatch = useTypedDispatch()
  const item = useTypedSelector(getPaymentItem)
  const charge = useTypedSelector(getPaymentCharge)
  const chargeType = useTypedSelector(getChargeType)
  const isUpdating = useTypedSelector(isUpdatingBillingCycle)
  const paymentIntent = useParamSelector(getPaymentIntent, item?.id)

  const chargeMonths = charge?.months || 1
  const isNotRecurrentPayment = chargeType !== PAYMENT.FREQUENCY.MONTHLY

  const [selectedOption, setSelectedOption] = useState<IPickerListItem[]>(
    getBillingCycleOption(chargeMonths)
  )

  if (!charge || isNotRecurrentPayment) {
    return null
  }

  const handleBillingCycleChange = (
    selectedItems: IPickerListItem[] | null
  ) => {
    if (!selectedItems || selectedItems[0].key === selectedOption[0].key) {
      return
    }

    const months =
      selectedItems[0].key === BILLING_OPTIONS.annually.key ? 12 : 1
    const price = calculateUpdatedChargePrice(item.payment.price, months)

    setSelectedOption(selectedItems)
    dispatch(
      createCharge({ paymentIntent: { ...paymentIntent, item, months, price } })
    )
  }

  return (
    <>
      <Picker
        id="billing-cycle"
        hideClearButton
        searchDisabled
        options={optionsList}
        selected={selectedOption}
        onSelect={handleBillingCycleChange}
        disabled={isUpdating}
      />

      {selectedOption[0].key === BILLING_OPTIONS.monthly.key && (
        <Text
          size="sm"
          customColor={withVar(DesignToken.ActionPositiveDefault)}
          data-test="ocp-save-annual-text"
        >
          Save 15% with annual
        </Text>
      )}
    </>
  )
}

export default BillingCyclePicker
